import { useContext } from "react";

import Context from "../../../../../context";

export default function useGetPositionActiveRows() {
	const { state } = useContext(Context);

	if (!state.demoData) return { positions: [] };

	const { activePositions } = state.demoData;

	const totalAmount = activePositions.reduce((acc, position) => acc + position.amount, 0);
	const newPositions = activePositions.map((position) => ({
		...position,
		weight: (position.amount / totalAmount) * 100
	}));

	return {
		positions: newPositions
	};
}
